document.addEventListener("DOMContentLoaded", function () {
  const CONTAINER = ".ll__cart-ho4ed3";      // the block with your login link
  const DRAWER    = ".drawer--container";    // cart drawer root (for re-renders)

  function getLocale() {
    return (window.Shopify && Shopify.locale) || (document.documentElement.getAttribute("lang") || "").trim();
  }
  function getRegionCountry() {
    try {
      if (window.Shopify?.country) return Shopify.country;                 // e.g. "AT"
      if (window.Shopify?.market?.iso_code) return Shopify.market.iso_code;
    } catch (_) {}
    const html = document.documentElement;
    return html.getAttribute("data-country") || html.getAttribute("data-default-country") || "";
  }

  function rewriteCartLoginLinks(root = document) {
    const locale = getLocale();
    const regionCountry = getRegionCountry();

    const loginUrl = new URL("/customer_authentication/login", window.location.origin);
    loginUrl.searchParams.set("return_to", "/cart");
    if (locale)        loginUrl.searchParams.set("locale", locale);
    if (regionCountry) loginUrl.searchParams.set("region_country", regionCountry);

    root.querySelectorAll(`${CONTAINER} a[href]`).forEach(a => {
      // Only rewrite once per node
      if (a.dataset.loginRewritten === "true") return;
      a.href = loginUrl.toString();
      a.dataset.loginRewritten = "true";

      // Belt-and-suspenders: enforce navigation even if other scripts mutate href later
      a.addEventListener("click", function (e) {
        e.preventDefault();
        window.location.assign(loginUrl.toString());
      });
    });
  }

  // Run once
  rewriteCartLoginLinks();

  // Re-apply when the cart drawer re-renders
  const drawerEl = document.querySelector(DRAWER);
  if (drawerEl) {
    const mo = new MutationObserver(() => rewriteCartLoginLinks(drawerEl));
    mo.observe(drawerEl, { childList: true, subtree: true });
  }

  // Some themes emit these events; harmless if they don’t
  ["shopify:section:load", "cart:open", "cart:refresh", "cart:updated"].forEach(evt =>
    document.addEventListener(evt, () => rewriteCartLoginLinks())
  );
});
